<custom-charging [isLoading]="isLoading"></custom-charging>
<custom-header [logoImage]="logoImage" [companyName]="companyName"></custom-header>
<div class="container">
    <ng-content></ng-content>
</div>
<custom-footer *ngIf="!isLoading" [dataInfo]="dataInfo"></custom-footer>
<a [href]="whatsappUrl" target="_blank" class="whatsapp" [pTooltip]="whatsAppHoverMessage">
  <img src="../../../../assets/images/whatsApp.svg" width="35" height="35"/>
</a>
